import Sm2Company from '@/utils/smUtil';

// 获取随机字符串
export function getRandomStr(num = 32) {
  const strList = [
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
  ];
  const length = strList.length;
  return new Array(num).fill(null).map(() => {
    const index = Math.round(length * Math.random());
    return strList[index];
  }).join('');
}
// ticket解密
export function ticketDecrypt(ticketRes) {
  if(ticketRes) {
    // 解密得到ticket
    let sm4_Key = Sm2Company.sm2Decrypt(ticketRes.encryptKey);
    let sm4DecryptData = Sm2Company.sm4Decrypt(ticketRes.encryptData, sm4_Key);
    let { ticket } = sm4DecryptData;

    // 使用对方公钥加密
    // 我方生成sm4Key，并使用sm4Key加密ticket
    let { encryptData, sm4Key } = Sm2Company.sm4Encrypt(JSON.stringify({ ticket }));
    // 我方使用sm2加密sm4Key（对方的publicKey）
    let encryptKey = Sm2Company.sm2Encrypt(sm4Key);
    // 我方使用sm2签名（我方的privateKey）
    let signature = Sm2Company.generalSignature(encryptData + encryptKey + '');
    return {
      encryptData,
      encryptKey,
      signature
    };
  }
  return {};
}

// 获取当前环境
export function getCurrentEnv() {
  const currentUrl = window.location.href;
  let env = '';
  if (currentUrl.includes('dev') || currentUrl.includes('localhost')) {
    env = 'stage-';
  } else if (currentUrl.includes('test')) {
    env = 'test-';
  } else if (currentUrl.includes('stage')) {
    env = 'stage-';
  } else {
    env = '';
  }
  return env;
}
